import React from "react"

import { styled } from "@mui/material"
import MuiTooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip"

const TOOLTIP_MARGIN = "0.4rem"
const ENTER_DELAY = 500

export const BasicTooltip = styled(({ className, children, ...props }: TooltipProps) => (
  <MuiTooltip
    enterDelay={ENTER_DELAY}
    enterTouchDelay={ENTER_DELAY}
    enterNextDelay={ENTER_DELAY}
    {...props}
    classes={{ popper: className }}
  >
    {children}
  </MuiTooltip>
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: "1.2rem 1.6rem",

    backgroundColor: "#F2F2F2", // TODO: Pass from theme
    borderRadius: "1.2rem",
    boxShadow: "0px 1px 4px 0px #0000004D",

    color: "#737373", // TODO: Pass from theme
    fontFamily: "Open Sans, sans-serif",
    fontSize: "1.4rem",
    fontWeight: 400,
    lineHeight: "2rem",
  },
  [`&.${tooltipClasses.popper} .${tooltipClasses.tooltip}`]: {
    [`&.${tooltipClasses.tooltipPlacementTop}`]: {
      marginBottom: TOOLTIP_MARGIN,
    },
    [`&.${tooltipClasses.tooltipPlacementRight}`]: {
      marginLeft: TOOLTIP_MARGIN,
    },
    [`&.${tooltipClasses.tooltipPlacementBottom}`]: {
      marginTop: TOOLTIP_MARGIN,
    },
    [`&.${tooltipClasses.tooltipPlacementLeft}`]: {
      marginRight: TOOLTIP_MARGIN,
    },
  },
}))
